import { makeStyles } from '@material-ui/core';
export const useDrawerStyles = makeStyles({
    root: {
        '& .MuiDrawer-paper': {
            height: 'calc(100% - 50px)',
            top: '50px'
        }
    },
    backdrop: {
        backgroundColor: "rgba(0,0,0,0.2)"
    },
    paper: {
        boxShadow: '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 4px 16px 4px rgba(0,0,0,0.12)'
    }
});
